export class AuthStorage {
  // the promise returned from sync function
  static syncPromise = null;

  // check to see if we should be using session or local storage
  static checkForRememberMe(): boolean {
    if (localStorage.getItem("aws-amplify-remember-me") !== "true") {
      return false;
    }
    return true;
  }

  // set item with the key
  static setItem(key: string, value: string): string {
    const useLocalStorage = this.checkForRememberMe();

    if (useLocalStorage) {
      localStorage.setItem(key, value);
    } else {
      sessionStorage.setItem(key, value);
    }
    return key;
  }

  // get item with the key
  static getItem(key: string): string {
    const useLocalStorage = this.checkForRememberMe();

    if (useLocalStorage) {
      return localStorage.getItem(key);
    }
    return sessionStorage.getItem(key);
  }

  // remove item with the key
  static removeItem(key: string): void {
    const useLocalStorage = this.checkForRememberMe();

    if (useLocalStorage) {
      return localStorage.removeItem(key);
    }
    return sessionStorage.removeItem(key);
  }

  // clear out the storage
  static clear(): void {
    const useLocalStorage = this.checkForRememberMe();

    if (useLocalStorage) {
      localStorage.clear();
    } else {
      sessionStorage.clear();
    }
  }

  // If the storage operations are async(i.e AsyncStorage)
  // Then you need to sync those items into the memory in this method
  static sync(): Promise<void> {
    return new Promise((resolve, reject) => {
      resolve();
    });
  }
}
